import {api} from '@/data/api/auth'

export interface UserActivity {
  page: string,
  referer: string,
}

export async function logWebUserActivity(ua: UserActivity): Promise<string> {
  try {
    const r = await api.post('/logWebUserActivity', ua)
    if (!r || !r.data) {
      return 'error'
    } else {
      return r.data
    }
  } catch (err) {
    return 'error'
  }
}
